import React from 'react';
import UserFolders from './user-folders/UserFolders';
import {InboxSidebarNav} from './InboxSidebarNav';
import './InboxSidebar.styl';

export default class InboxSidebar extends React.PureComponent {
  render() {
    const {filters, folders, location, onSelectFolder} = this.props;

    return (
      // TODO Wrapping div here is important to give something to stick to
      // If sidebar can stick without this, please remove
      <div>
        <div className="inbox-sidebar">
          <InboxSidebarNav
            inbox={folders.find(f => f.isInbox())}
            outbox={folders.find(f => f.isOutbox())}
            filters={filters}
            onSelectFolder={onSelectFolder}
            location={location}
          />
          <UserFolders
            folders={folders.filterNot(f => f.isInbox() || f.isOutbox())}
            filters={filters}
            onSelectFolder={onSelectFolder}
          />
        </div>
      </div>
    );
  }
}
